/**
 * @version:               1.0.0
 * @createTime:            2021.10.08
 * @updateTime:            2021.10.08
 * @author:                zhangju
 * @description
 ***/

import fdDataTable from '@/js/app/dataTable/fdDataTable';
export default {
    name: 'content-table-01',
    props: {
        tab: {
            type: String,
            default: ''
        },
        hideQuery: {
            type: Boolean,
            default: false
        },
        // 当前组件属于哪个模块
        activePage:{
            type: String,
            default: ''
        }
    },
    data() {
        return {
            routeData:{},
            fbdwList: [],
            dataList:{
                dywz: '3',
                spnk: '4',
                bps: '5',
                sfjy: '6',
                sfjs: '7',
                flfg: '8',
                zdxwj: '9',
                ywfl: '10',
                gjxg: '11',
                ywzc: '12',
                ywpj: '13',
                gjgy: '14',
                hszcjj: '15',
                alfx: '16',
                yjbg: '17'
            },
            query: {
                title: null,
                gbjg: null,
                yxx: '',
                flwj: ''
            },
            yxxList: fdDataTable.yyxList,
            flwjList: fdDataTable.flwjList,
            data: {
                offset: 0,
                limit: 10,
                total: null,
                data: null
            }
        };
    },
    mounted() {
        this.routeData = this.$route.query;
        this.init();
        this.getFbdwList();
    },
    methods: {
        init() {
            this.handleSearch();
        },
        // 点击跳转详情
        handleToDetail(item) {
            const url = this.$router.resolve({path: '/lltt/dedail', query: {active:'ywsf', bh: item.bh, ejlb: item.ejlb}});
            window.open(url.href, '_blank');
            window.console.log(item);
        },
        pageInformation(pageInfo) {
            this.query.limit = pageInfo.limit;
            this.query.offset = pageInfo.offset;
            this.handleSearch();
        },
        // 查询
        handleSearch() {
            this.query.ejlb = this.dataList[this.tab];
            window.fdGlobal.ajax({
                method: window.fdConfig.methodGet,
                url: window.fdConfig.url.Hsal.HsalpageOut,
                params: this.query
            }).then((res) => {
                this.data = res.data;
            })
                .catch(() => {
                    Artery.notice.warning({
                        title: '失败',
                        desc: '查询列表失败！',
                        duration: 1
                    });
                });
        },
        searchButton() {
            this.query.limit = 10;
            this.query.offset = 0;
            this.handleSearch();
        },
        // 重置
        handleReset() {
            this.query = {
                xwbt: null,
                gbjg: null,
                yxx: '',
                flwj: ''
            };
            this.handleSearch();
        },
        getFbdwList() {
            window.fdGlobal.ajax({
                method: window.fdConfig.methodGet,
                url: window.fdConfig.url.Hsal.fbdwList
            }).then((res) => {
                if (res.data) {
                    this.fbdwList = res.data;
                }
            });
        }
    }
};
